/**
 * Navigation shape and the buyer destinations.
 *
 * Split out from BottomNav.tsx so both nav components export only components.
 *
 * Five destinations is the maximum that leaves each one a comfortable thumb
 * target at 393px (§11: touch targets ≥ 44px), which is why Account absorbs
 * everything secondary rather than a sixth tab appearing.
 */

import type { IconName } from '@/components/icons/iconPaths';

export interface NavItem {
  to: string;
  label: string;
  icon: IconName;
  /** A count, or a bare dot when the number does not matter. */
  badge?: number | true;
  end?: boolean;
}

export const buyerNav: NavItem[] = [
  { to: '/', label: 'Home', icon: 'home', end: true },
  { to: '/search', label: 'Search', icon: 'search' },
  { to: '/cart', label: 'Cart', icon: 'cart' },
  { to: '/orders', label: 'Orders', icon: 'orders' },
  { to: '/account', label: 'Account', icon: 'user' },
];

/**
 * The same five destinations, on the animal-health side of the wall.
 *
 * Home and Search are sector-scoped and Cart, Orders and Account are not — one
 * person with one account and one order history, however many kinds of thing
 * they buy. Tapping Cart from the vet end deliberately leaves the vet end,
 * which is why the tab bar changes colour back the moment it does.
 */
export const vetNav: NavItem[] = [
  { to: '/vet', label: 'Home', icon: 'home', end: true },
  { to: '/vet/search', label: 'Search', icon: 'search' },
  { to: '/cart', label: 'Cart', icon: 'cart' },
  { to: '/orders', label: 'Orders', icon: 'orders' },
  { to: '/account', label: 'Account', icon: 'user' },
];

export function navFor(sector: 'human' | 'veterinary'): NavItem[] {
  return sector === 'veterinary' ? vetNav : buyerNav;
}

